module.exports = "/assets/cola-page/logo_2@2x.png?O47x00d";